import axios from "axios";
import { useErrorBoundary } from "component-library";
import { config } from "config";
import { UserManager } from "core";
import { socialMediaQueryKey } from "pages/Profile/components/SocialMediaSection/constants";
import { useQuery } from "react-query";
import { getUserAttribute, UserAttributes } from "shared-auth";

export function useGetSocialMedia(isInstagramIntegrationEnabled: boolean) {
  const captureError = useErrorBoundary();
  const profileIdAttr =
    UserManager.userId || getUserAttribute(UserAttributes.MasterPortalGuid);

  return useQuery(
    [socialMediaQueryKey, isInstagramIntegrationEnabled, profileIdAttr],
    {
      queryFn: async () => {
        const { data } = await axios(
          `${config.profileApiUrl}/profiles/${profileIdAttr}/social/accounts`
        );

        return data.accounts.reduce((acc: any, res: any) => {
          return { ...acc, [res.platformCode]: res };
        }, {});
      },
      enabled: isInstagramIntegrationEnabled,
      onError: captureError,
    }
  );
}
